//=include _pages/*
// ------------------------------------------
// imgタグに「js-color-parallax」クラス、そのimgタグに要素をラップしてheightを指定すると、画像がはみ出た分が動く
// 「data-scrub」属性に数字を入れると、動きの滑らかさが変わる
// 画面内に完全に表示されたらカラーになる。それ以外は白黒。
// ------------------------------------------
class ColorParallax {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
  }

  event() {
    let cls = this.el;
    let para_ele = document.querySelectorAll("." + this.el);

    para_ele.forEach((ele, index) => {
      let property, scrub;

      $(ele).css({
        "object-fit": "cover",
        "object-position": "50% 0%",
        width: "100%",
        height: "100%",
        filter: "grayscale(100%)", // 初期は白黒
        transition: "filter 0.5s ease",
      });

      property = "50% 100%";
      scrub = $(ele).data("scrub") ? $(ele).data("scrub") : 3;

      ele.classList.add(cls + index);

      // パララックス
      gsap.to("." + cls + index, {
        objectPosition: property,
        scrollTrigger: {
          trigger: "." + cls + index,
          start: "top bottom",
          end: "bottom top",
          scrub: scrub,
        },
      });

      // 白黒 → カラー制御
      gsap.to(ele, {
        filter: "grayscale(0%)",
        scrollTrigger: {
          trigger: ele,
          start: "bottom bottom",
          end: "top top",
          toggleActions: "play reverse play reverse",
        },
      });
    });
  }
}


// 参考サイト
// https://hacknote.jp/archives/15289/

let cookie = {
	/**
	 * 取得
	 * @param {string} cookieName 取得するCookieの名前
	 */
	get : function(cookieName) {
		if (!navigator.cookieEnabled) return false;

		var getCookieAllData  = document.cookie,
		    getCookieAllDatas = getCookieAllData.split(';'),
		    getCookieDatas    = {},
		    cookieKeyValue    = [],
		    cookieKey         = '',
		    cookieValue       = '';

		var hashLength = function(arr) {
			var result = 0, key = false;

			if (typeof arr !== 'object') return false;

			for (key in arr) result++;

			return result;
		};

		for (var i = 0, len = getCookieAllDatas.length; i < len; i++) {
			if (getCookieAllDatas[i] && getCookieAllDatas[i] !== '') {
				cookieKeyValue = getCookieAllDatas[i].split('=');
				cookieKey      = cookieKeyValue[0].replace(/^\s+/, '');
				cookieValue    = '';

				if (cookieKeyValue[1]) {
					cookieValue = decodeURIComponent(cookieKeyValue[1]);
				}

				getCookieDatas[cookieKey] = cookieValue;
			}
		}

		if (hashLength(getCookieDatas) > 0) {
			if (cookieName && cookieName in getCookieDatas) {
				return getCookieDatas[cookieName];
			} else {
				return getCookieDatas;
			}
		} else {
			return '';
		}
	},

	/**
	 * 設定
	 * @param {string} cookieName 設定するCookieの名前
	 * @param {string} value 設定する値
	 * @param {string} domain 有効ドメイン
	 * @param {string} path 有効パス
	 * @param {string} expires 有効期限
	 * @param {boolean} secure セキュアとするか
	 * @return {boolean} 設定に成功した場合はtrue、失敗した場合はfalseを返す
	 */
	set : function(cookieName, value, domain, path, expires, secure) {
		if (!navigator.cookieEnabled || !cookieName || !value) return false;

		var date, dt, ts, ts_after;

		var setCookieData = cookieName + '=' + encodeURIComponent(value) + ';';

		if (domain) setCookieData += 'domain=' + domain + ';';

		if (path) setCookieData += 'path=' + path + ';';

		if (expires) {
      dt = new Date();
      ts = dt.getTime();

      // 1時間後
      ts_after = ts + (1000 * 60 * 60 * expires);

      date = new Date(ts_after);
			setCookieData += 'expires=' + date.toGMTString() + ';';
		}

		if (secure && secure === true && location.protocol.match(/https/)) {
			setCookieData += 'secure';
		}

		document.cookie = setCookieData;

		return true;
	},

	/**
	 * 削除
	 * @param {string} cookieName 削除するCookieの名前
	 * @return {boolean} 削除に成功した場合はtrue、失敗した場合はfalseを返す
	 */
	del : function(cookieName) {
		if (!navigator.cookieEnabled || !cookieName) return false;

		var getCookieDatas = this.get();

		if (getCookieDatas[cookieName]) {
			var setCookieData = cookieName + '=;',
			    date          = new Date(0);

			setCookieData += 'expires=' + date.toGMTString() + '';

			document.cookie = setCookieData;

			return true;
		}

		return false;
	}
};
class FormConvert {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    //全角から半角
    function replaceZtoH(str){
      str = str.replace(/[！-～]/g, function(s){
        return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
      });
      str = str.replace(/[-－﹣−‐⁃‑‒–—﹘―⎯⏤ーｰ─━]/g, '-');
      return str;
    }
    const el = document.querySelector('.js-convert');
    el.addEventListener('blur', () => {
      const br = el.value;
      const ar = replaceZtoH(br);
      el.value = ar;
    });
  }
}

class Header {
  constructor(el,opt){
    this.el = el;
    this.header = document.querySelector('.l-header');
    this.mvSection = document.querySelector('.s-mv');
    this.scrollThreshold = 0;
    this.scrollPosition = 0; // スクロール位置を保存する変数を追加
    this.init();
    if($("." + this.el).length > 0){
      this.event();
    }
  }

  init() {
    // s-mvセクションの下面から20px上の位置を計算
    if (this.mvSection) {
      const mvRect = this.mvSection.getBoundingClientRect();
      const mvBottom = mvRect.bottom + window.scrollY;
      this.scrollThreshold = mvBottom - 30;
    }
    
    // スクロールイベントリスナーを追加
    window.addEventListener('scroll', this.handleScroll.bind(this));
    
    // 初期状態をチェック
    this.handleScroll();
  }

  handleScroll() {
    if (!this.header || !this.mvSection) return;
    
    const scrollY = window.scrollY;
    
    // スクロール位置が閾値を超えたかチェック
    if (scrollY >= this.scrollThreshold) {
      this.header.classList.add('is-scroll');
    } else {
      this.header.classList.remove('is-scroll');
    }
    
    // スクロール位置が1px以上の場合、bodyにis-scrolledクラスを追加
    if (scrollY > 0) {
      document.body.classList.add('is-scrolled');
    } else {
      document.body.classList.remove('is-scrolled');
    }
  }

  event(){
    // ハンバーガーメニューのトグル機能
    const hamburgerBtn = document.querySelector('.hn-btn');
    
    if (hamburgerBtn) {
      hamburgerBtn.addEventListener('click', () => {
        this.header.classList.toggle('is-active');
        
        if (document.body.classList.contains('is-fixed')) {
          // メニューを閉じる時
          document.body.classList.remove('is-fixed');
        } else {
          // メニューを開く時
          this.scrollPosition = window.scrollY; // 現在のスクロール位置を保存
          document.body.classList.add('is-fixed');
        }
      });
    }

    // メガメニューのリンクをクリックした時にメニューを閉じる
    const megaMenuLinks = document.querySelectorAll('.mega-menu-inner ul li a');
    megaMenuLinks.forEach(link => {
      link.addEventListener('click', () => {
        // メニューを閉じる
        this.header.classList.remove('is-active');
        
        if (document.body.classList.contains('is-fixed')) {
          // スクロール禁止を解除
          document.body.classList.remove('is-fixed');
        }
      });
    });
  }
}

class ImageModal {
  constructor() {
    this.modal = document.querySelector('.image-modal');
    this.modalImage = document.querySelector('.modal-image');
    this.triggers = document.querySelectorAll('.gallery-image-trigger');
    this.scrollPosition = 0;
    
    console.log('ImageModal constructor called');
    console.log('Modal element:', this.modal);
    console.log('Modal image element:', this.modalImage);
    console.log('Trigger elements:', this.triggers.length);
    
    if (this.modal && this.modalImage && this.triggers.length > 0) {
      this.init();
    } else {
      console.error('ImageModal: Required elements not found');
      if (!this.modal) console.error('Modal element not found');
      if (!this.modalImage) console.error('Modal image element not found');
      if (this.triggers.length === 0) console.error('Trigger elements not found');
    }
  }

  init() {
    console.log('ImageModal initialized');
    console.log('Triggers found:', this.triggers.length);
    console.log('Modal found:', !!this.modal);
    console.log('Modal image found:', !!this.modalImage);
    
    // 画像クリック時のイベントリスナーを追加
    this.triggers.forEach((trigger, index) => {
      console.log(`Adding click listener to trigger ${index}`);
      
      // 既存のイベントリスナーを削除してから追加
      trigger.removeEventListener('click', this.handleImageClick);
      trigger.addEventListener('click', this.handleImageClick.bind(this));
    });

    // モーダルを閉じる処理
    this.setupCloseHandlers();
  }

  handleImageClick(e) {
    e.preventDefault();
    e.stopPropagation();
    console.log('Image clicked!');
    const img = e.currentTarget.querySelector('img');
    if (img) {
      console.log('Opening modal with image:', img.src);
      this.openModal(img);
    }
  }

  openModal(img) {
    // 現在のスクロール位置を保存
    this.scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
    console.log('Scroll position saved:', this.scrollPosition);
    
    // 画像のsrcを設定
    this.modalImage.src = img.dataset.src || img.src;
    this.modalImage.alt = img.alt;
    
    // スクロールバーを調整
    this.adjustScrollbar();
    
    // モーダルを表示
    this.modal.classList.add('is-active');
    document.body.classList.add('is-fixed');
    
    // スクロール位置を固定
    document.body.style.top = `-${this.scrollPosition}px`;
  }

  closeModal() {
    this.modal.classList.remove('is-active');
    document.body.classList.remove('is-fixed');
    
    // スクロール位置を復元
    this.restoreScrollPosition();
  }

  setupCloseHandlers() {
    // 閉じるボタンをクリックしたとき
    const closeBtn = this.modal.querySelector('.btn');
    if (closeBtn) {
      closeBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.closeModal();
      });
    }

    // モーダル背景をクリックしたとき
    this.modal.addEventListener('click', (e) => {
      if (e.target === this.modal) {
        this.closeModal();
      }
    });

    // ESCキーでモーダルを閉じる
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.modal.classList.contains('is-active')) {
        this.closeModal();
      }
    });
  }

  // スクロールバーを調整
  adjustScrollbar() {
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    document.body.style.paddingRight = `${scrollbarWidth}px`;
  }

  // スクロール位置を復元
  restoreScrollPosition() {
    // スクロールバーの調整を解除
    document.body.style.paddingRight = '';
    document.body.style.top = '';
    
    // スクロール位置を復元（requestAnimationFrameを使用してより確実に）
    requestAnimationFrame(() => {
      window.scrollTo(0, this.scrollPosition);
    });
  }
}
// ------------------------------------------
// imgタグに「js-parallax」クラス、そのimgタグに要素をラップしてheightを指定すると、画像がはみ出た分が動く
// 「data-scrub」属性に数字を入れると、動きの滑らかさが変わる
// ------------------------------------------
class ImgParallax {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    let cls = this.el;
    let para_ele = document.querySelectorAll("." + this.el);
    para_ele.forEach((ele, index)=> {
      let property,scrub;

      $(ele).css({
        'object-fit':'cover',
        'object-position':'50% 0%',
        'width':'100%',
        'height':'100%',
      })

      property = '50% 100%';
      scrub = $(ele).data('scrub') ? $(ele).data('scrub') : 3;

      ele.classList.add(cls + index);
      gsap.to('.' + cls + index, {
        objectPosition: property,
        scrollTrigger: {
          trigger: '.' + cls + index, // 要素がビューポートに入ったときにアニメーション開始
          start: 'top bottom',
          end: 'bottom top',
          scrub: scrub,
        }
      })
    })
  }
}

class InviewEvent {
  constructor(el, opt){
    $('.js-load-inview').animate({'opacity': '1'});
    this.el = "." + el;
    this.all = this.el + '-all';
    this.eachUp = this.el + '-each';
    this.eachItem = this.el + '-eachItem';
    this.eachItemFast = this.el + '-eachItem-fast';
    this.eachItemDelay = this.el + '-eachItem-delay';
    if($(this.el).length > 0){
      this.event();
    }
  }
  event() {
    let options = {
      threshold: [0, 0.05, 0.1, 1]
    }
    let optionsAll = {
      threshold: [0, 0.9, 1]
    }
    const observerEnter = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const item = entry.target;
        if(entry.intersectionRatio >= 0.05){
          item.classList.add('is-inview');
          if(item.classList.contains('js-inview-each')){
            this.inviewEachUp(item);
          }
          if(item.classList.contains('js-inview-lottie')){
            this.inviewLottie(item);
          }
          observerEnter.unobserve(item);
        }
      });
    }, options);
    const observerAll = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const item = entry.target;
        if(entry.intersectionRatio >= 0.9){
          item.classList.add('is-inview');
          if(item.classList.contains('js-inview-each')){
            this.inviewEachUp(item);
          }
          observerAll.unobserve(item);
        } else {
          item.classList.remove('is-inview');
        }
      });
    }, optionsAll);
    const inviewItem = document.querySelectorAll(this.el);
    const inviewAllItem = document.querySelectorAll(this.all);
    inviewItem.forEach((e)=>{
      observerEnter.observe(e);
    });
    inviewAllItem.forEach((e)=>{
      observerAll.observe(e);
    });
  }
  inviewEachUp(item){
    $(item).find(this.eachItem).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.4 * i),
        // y: 0
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
    $(item).find(this.eachItemFast).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.1 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
    $(item).find(this.eachItemDelay).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.5 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
  }
  inviewLottie(item){
    if($(item).hasClass('js-lottie-flow')) {
      lottie.flow();
    }
    if($(item).hasClass('js-lottie-no01')) {
      lottie.no01();
    }
    if($(item).hasClass('js-lottie-no02')) {
      lottie.no02();
    }
    if($(item).hasClass('js-lottie-no03')) {
      lottie.no03();
    }
    if($(item).hasClass('js-lottie-no04')) {
      lottie.no04();
    }
    if($(item).hasClass('js-lottie-no05')) {
      lottie.no05();
    }
    if($(item).hasClass('js-lottie-no06')) {
      lottie.no06();
    }
    if($(item).hasClass('js-lottie-no07')) {
      lottie.no07();
    }
  }
}

class Modal {
  constructor(el, opt) {
    this.el = el;
    this.scrollPosition = 0; // スクロール位置を保存する変数
    if ($("." + this.el).length > 0) {
      this.init();
    }
  }

  init() {
    // モーダルトリガー要素を取得
    const triggers = document.querySelectorAll('[class*="-modal-trigger"]');

    triggers.forEach((trigger) => {
      trigger.addEventListener("click", (e) => {
        e.preventDefault();

        // クラス名からモーダルIDを抽出
        const classList = Array.from(trigger.classList);
        const modalClass = classList.find((cls) =>
          cls.includes("-modal-trigger")
        );

        if (modalClass) {
          // -modal-triggerを-modalに置換してモーダル要素を特定
          const modalSelector =
            "." + modalClass.replace("-modal-trigger", "-modal");
          const modal = document.querySelector(modalSelector);

          if (modal) {
            // 現在のスクロール位置を保存
            this.scrollPosition =
              window.pageYOffset || document.documentElement.scrollTop;

            modal.classList.add("is-active");
            // モーダルを開く時にis-fixedクラスを追加
            document.body.classList.add("is-fixed");

            // スクロールバーを調整
            this.adjustScrollbar(modal);
          }
        }
      });
    });

    // モーダルを閉じる処理（オプション）
    this.setupCloseHandlers();
  }

  setupCloseHandlers() {
    // close-btnをクリックしたらモーダルを閉じる
    document.addEventListener("click", (e) => {
      if (e.target.closest(".close-btn") || e.target.closest(".btn")) {
        const modal =
          e.target.closest('[class*="-modal"]') || e.target.closest(".s-modal");
        if (modal) {
          modal.classList.remove("is-active");
          // モーダルを閉じる時にis-fixedクラスを削除
          this.removeIsFixed();
          // スクロール位置を復元
          this.restoreScrollPosition();
        }
      }

      // モーダル背景をクリックしたらモーダルを閉じる
      if (
        e.target.matches('[class*="-modal"]') &&
        e.target === e.currentTarget
      ) {
        e.target.classList.remove("is-active");
        // モーダルを閉じる時にis-fixedクラスを削除
        this.removeIsFixed();
        // スクロール位置を復元
        this.restoreScrollPosition();
      }

      // s-modal背景をクリックしたらモーダルを閉じる
      if (e.target.matches(".s-modal") && e.target === e.currentTarget) {
        e.target.classList.remove("is-active");
        // モーダルを閉じる時にis-fixedクラスを削除
        this.removeIsFixed();
        // スクロール位置を復元
        this.restoreScrollPosition();
      }
    });

    // ESCキーでモーダルを閉じる
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") {
        const activeModal =
          document.querySelector('[class*="-modal"].is-active') ||
          document.querySelector(".s-modal.is-active");
        if (activeModal) {
          activeModal.classList.remove("is-active");
          // モーダルを閉じる時にis-fixedクラスを削除
          this.removeIsFixed();
          // スクロール位置を復元
          this.restoreScrollPosition();
        }
      }
    });
  }

  // is-fixedクラスを削除する処理
  removeIsFixed() {
    // 他のモーダルが開いているかチェック
    const hasActiveModal =
      document.querySelector('[class*="-modal"].is-active') ||
      document.querySelector(".s-modal.is-active");

    // アクティブなモーダルがなければis-fixedクラスを削除
    if (!hasActiveModal) {
      document.body.classList.remove("is-fixed");
    }
  }

  // スクロール位置を復元する処理
  restoreScrollPosition() {
    // 他のモーダルが開いているかチェック
    const hasActiveModal =
      document.querySelector('[class*="-modal"].is-active') ||
      document.querySelector(".s-modal.is-active");

    // アクティブなモーダルがなければスクロール位置を復元
    if (!hasActiveModal) {
      // 少し遅延を入れてからスクロール位置を復元
      setTimeout(() => {
        window.scrollTo(0, this.scrollPosition);
      }, 10);
    }
  }
}


// -------------------------------------------------
// スクロール禁止
// -------------------------------------------------
let scrollTop = 0;

function scrollBan() {
  const body = $('html')[0];
  if (body.classList.contains('is-hidden')) {
    // スクロール開放
    body.style.top = '';
    body.classList.remove('is-hidden');
    window.scrollTo(0, scrollTop);
  } else {
    // スクロール禁止
    scrollTop = window.scrollY;
    body.style.top = (scrollTop * -1) + 'px';
    body.classList.add('is-hidden');
  }
}
class SlideToggle {
  constructor(el, opt) {
    this.el = el;
    this.toggleBtn = document.querySelector("." + this.el);
    this.toggleText = null;
    this.moreItems = null;
    this.isExpanded = false;

    if (this.toggleBtn) {
      this.init();
    }
  }

  init() {
    this.toggleText = document.querySelector(".gallery-toggle-text");
    this.moreItems = document.querySelectorAll(".gallery-more-item");
    this.moreItemsSp = document.querySelectorAll(".gallery-more-item-sp");
    this.iconFigure = this.toggleBtn.querySelector(".c-right-aro");

    // 必要な要素が存在しない場合は終了
    if (!this.toggleText || this.moreItems.length === 0) {
      return;
    }

    this.setupEventListeners();
    this.initSpItems();
  }

  // SP版の初期状態を設定
  initSpItems() {
    const isSp = window.innerWidth <= 767;
    if (isSp && this.moreItemsSp.length > 0) {
      this.moreItemsSp.forEach((item) => {
        item.classList.add("hidden");
        item.style.height = '0';
        item.style.opacity = '0';
        item.style.overflow = 'hidden';
      });
    }
  }

  setupEventListeners() {
    this.toggleBtn.addEventListener("click", (e) => {
      e.preventDefault();
      this.toggle();
    });
  }

  toggle() {
    this.isExpanded = !this.isExpanded;

    if (this.isExpanded) {
      // 展開する場合
      this.expand();
    } else {
      // 閉じる場合
      this.collapse();
    }
  }

  expand() {
    const isSp = window.innerWidth <= 767;
    
    // 展開する要素を決定
    const itemsToExpand = isSp 
      ? [...this.moreItemsSp, ...this.moreItems]
      : [...this.moreItems];
    
    // アコーディオン風に展開（全体で一斉に）
    itemsToExpand.forEach((item) => {
      // 最初にhiddenを外して要素を表示可能にする
      item.classList.remove("hidden");
      
      // 実際の高さを取得（display: blockで高さを正確に取得）
      item.style.height = 'auto';
      item.style.opacity = '0';
      item.style.overflow = 'hidden';
      const targetHeight = item.getBoundingClientRect().height;
      
      // 開始状態を設定（高さ0から）
      item.style.height = '0';
      
      // 強制的にレイアウトを再計算させる（reflow）
      item.offsetHeight;
      
      // 全体を一斉に展開
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          item.style.height = targetHeight + 'px';
          item.style.opacity = '1';
          
          // アニメーション完了後に高さをautoに戻す
          setTimeout(() => {
            item.style.height = 'auto';
            item.style.overflow = 'visible';
          }, 500);
        });
      });
    });

    // ボタンのテキストを変更
    this.toggleText.textContent = "CLOSE";

    // アイコンを-に変更
    if (this.iconFigure) {
      this.iconFigure.classList.add("is-minus");
    }

    // アニメーション完了後にスクロール
    setTimeout(() => {
      const firstMoreItem = this.moreItems[0];
      if (firstMoreItem) {
        const elementPosition = firstMoreItem.getBoundingClientRect().top + window.pageYOffset;
        const offsetPosition = elementPosition - 100;

        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth",
        });
      }
    }, 300);
  }

  collapse() {
    const isSp = window.innerWidth <= 767;
    
    // 閉じる要素を決定
    const itemsToCollapse = isSp 
      ? [...this.moreItemsSp, ...this.moreItems]
      : [...this.moreItems];
    
    // アコーディオン風に閉じる（全体で一斉に）
    itemsToCollapse.forEach((item) => {
      // まず現在の高さを取得して設定（autoの場合も正確に取得）
      const currentHeight = item.getBoundingClientRect().height;
      item.style.height = currentHeight + 'px';
      item.style.overflow = 'hidden';
      
      // 強制的にレイアウトを再計算させる（reflow）
      item.offsetHeight;
      
      // ブラウザに高さを認識させてからアニメーション開始
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          item.style.height = '0';
          item.style.opacity = '0';
          
          // アニメーション完了後にhiddenクラスを追加
          setTimeout(() => {
            item.classList.add("hidden");
            item.style.height = '';
            item.style.opacity = '';
            item.style.overflow = '';
          }, 500);
        });
      });
    });

    // ボタンのテキストを変更
    this.toggleText.textContent = "VIEW MORE";

    // アイコンを+に戻す
    if (this.iconFigure) {
      this.iconFigure.classList.remove("is-minus");
    }

    // GALLERYタイトルまでスクロール
    // アニメーション完了を待ってからスクロール
    setTimeout(() => {
      // GALLERYセクションのタイトルを探す
      const gallerySection = document.querySelector('.s-instagram');
      const galleryTitle = gallerySection ? gallerySection.querySelector('hgroup') : null;
      
      if (galleryTitle) {
        const titlePosition = galleryTitle.getBoundingClientRect().top + window.pageYOffset;
        const offsetPosition = titlePosition - 100; // 100px上にオフセット

        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth",
        });
      }
    }, 300); // アニメーション時間に合わせて調整
  }
}
class Top {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }


  event(){
    const targets = document.querySelectorAll('.s-parallax img');

    window.addEventListener('scroll', () => {
      targets.forEach((img) => {
        const parent = img.closest('.s-parallax');
        if (!parent) return;
    
        const rect = parent.getBoundingClientRect();
        const windowHeight = window.innerHeight;
        const isSp = window.innerWidth <= 767;
        const basePoint = isSp ? windowHeight -200 : windowHeight - 200;
    
        if (rect.top < basePoint) {
          const progress = Math.min((basePoint - rect.top) / rect.height, 1);
          const startY = isSp ? -14 : -20;
    
          const slowProgress = progress * 0.4; // スピードゆっくり（0.4倍）
          const translateY = startY + (-startY * slowProgress);
    
          img.style.transform = `translate(-50%, ${translateY}%)`;
        }
      });
    });

    // MV Swiper
    const mvSwiper = new Swiper('.mv-swiper', { // ←全mvの部分固有名に変える
      loop: true, 
      loopAdditionalSlides: 1, // ←ループモード時に複製するスライド数指定。基本的に1以上で設定しておく。
      slidesPerView: 1, // ←表示数
      centeredSlides: true, // ←センタースライド
      slidesOffsetBefore: 18, // ←パディング
      slidesOffsetAfter: 18, // ←パディング
      effect: 'fade', // ←追加 フェード機能をONにする
    
      speed: 2500, // ←切り替わるときの動きのスピード
      autoplay: { // ←自動再生
        delay: 4000, // 次のスライドに切り替わるまでの時間を指定(40秒)
        disableOnInteraction: false, // ←false にすればユーザーがドラッグなどの操作をしても自動再生が止まらない
      },
    
      breakpoints: { // ←ブレークポイント
        789: { // ←画面幅このpx以上
          slidesPerView: 1,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0,
        },
      },
    });

    const megaSwiper = new Swiper('.mega-swiper', { // ←全megaの部分固有名に変える
      loop: true, 
      loopAdditionalSlides: 1, // ←ループモード時に複製するスライド数指定。基本的に1以上で設定しておく。
      slidesPerView: 1, // ←表示数
      spaceBetween: 12, // ←間隔(gap)
      centeredSlides: true, // ←センタースライド
    
      autoplay: { // ←自動再生
        disableOnInteraction: false, // ←false にすればユーザーがドラッグなどの操作をしても自動再生が止まらない
      },
    });


    // // Course Menu Swiper
    // const dinnerimgSwiper = new Swiper('.dinnerimg-swiper', { // ←全dinnerimgの部分固有名に変える
    //   loop: true, 
    //   loopAdditionalSlides: 1, // ←ループモード時に複製するスライド数指定。基本的に1以上で設定しておく。
    //   slidesPerView: 1, // ←表示数
    //   spaceBetween: 12, // ←間隔(gap)
    //   centeredSlides: true, // ←センタースライド
    //   effect: 'fade',
    //   fadeEffect: {
    //     crossFade: true
    //   },
    
    //   speed: 1000, // ←切り替わるときの動きのスピード
    //   autoplay: { // ←自動再生
    //     delay: 3000, // 次のスライドに切り替わるまでの時間を指定(40秒)
    //     disableOnInteraction: false, // ←false にすればユーザーがドラッグなどの操作をしても自動再生が止まらない
    //   },
    //   pagination: {
    //     el: '.dinnerimg-swiper-pagination',
    //     type: 'custom',
    //     renderCustom: function (swiper, current, total) {
    //       // 現在のページ番号を2桁で表示（01, 02, 03...）
    //       const currentPage = String(current).padStart(2, '0');
    //       // 総ページ数を2桁で表示
    //       const totalPages = String(total).padStart(2, '0');
    //       return `${currentPage} / ${totalPages}`;
    //     }
    //   },
    // });

    // const dinnertxtSwiper = new Swiper('.dinnertxt-swiper', { // ←全dinnertxtの部分固有名に変える
    //   loopAdditionalSlides: 1, // ←ループモード時に複製するスライド数指定。基本的に1以上で設定しておく。
    //   slidesPerView: 1, // ←表示数
    //   effect: 'fade',
    //   fadeEffect: {
    //     crossFade: true
    //   },
      
    //   speed: 1000, // ←切り替わるときの動きのスピード
    //   autoplay: { // ←自動再生
    //     delay: 3000, // 次のスライドに切り替わるまでの時間を指定(40秒)
    //   },
    // });

    // // dinnerimg-swiperからdinnertxt-swiperへの連動
    // dinnerimgSwiper.on('slideChangeTransitionStart', () => {
    //   dinnertxtSwiper.slideToLoop(dinnerimgSwiper.realIndex);
    // });

    // // dinnertxt-swiperからdinnerimg-swiperへの連動
    // dinnertxtSwiper.on('slideChangeTransitionStart', () => {
    //   dinnerimgSwiper.slideToLoop(dinnertxtSwiper.realIndex);
    // });

    
  }
}


(() => {})();

//DOMContentLoaded
$(() => {
  // ImageModalをDOMContentLoadedでも初期化を試す
  let imageModal = new ImageModal();
});

//images resources loaded
$(window).on("load", () => {
  $(window).trigger("loading");
});

//after loading animation
$(window).on("loading", () => {
  let colorParallax = new ColorParallax("js-color-parallax");
  let imgParallax = new ImgParallax("js-parallax");
  let inviewEvent = new InviewEvent("js-inview");
  let formConvert = new FormConvert("js-convert");
  let top = new Top("p-top");
  let header = new Header("l-header");
  let modal = new Modal("s-modal");
  let imageModal = new ImageModal();
  let slideToggle = new SlideToggle("gallery-expand-trigger");
});

